export default __webpack_public_path__ + "static/media/noa-7.1bc0aeab.jpg";